import { useState, useEffect } from "react";
import { ListLayout } from "../../../layouts";
import { DataGrid, IconButton } from "../../../components";
import { ProdutosService, history, notification } from "../../../services";
import { responseErros, formatPrice } from "../../../utils";
import { filtrosUrl, PermisoesHelper } from "../../../helpers";
import { FiltroCustom, FormFiltroAvancado } from "./components";
import ImpressaoEtiquetasDialog from "./components/impressao-etiquetas-dialog.component";

const ListProdutos = () => {
  const [produtos, setProdutos] = useState([]);
  const [totalListaProdutos, setTotalListaProdutos] = useState(0);
  const [buscaFiltro, setBuscaFiltro] = useState("");
  const [openDialogImpressao, setOpenDialogImpressao] = useState(false);
  const colunas = [
    {
      field: "codigo",
      headerName: "Código",
      flex: 150,
      valueGetter: (params) => Number(params.value),
    },
    {
      field: "codigoBarra",
      headerName: "Barra",
      sortable: false,
      flex: 250,
    },
    {
      field: "descricao",
      headerName: "Descrição",
      flex: 650,
      filtrar: true,
    },
    {
      field: "tipo",
      headerName: "Tipo",
      sortable: false,
      flex: 220,
    },
    {
      field: "precoVenda",
      headerName: "Preço Venda",
      sortable: false,
      flex: 250,
      valueGetter: (params) => formatPrice(params.value),
    },
    {
      field: "estoque",
      headerName: "Estoque",
      sortable: false,
      flex: 220,
      valueGetter: (params) =>
        params.row?.fracionavel ? params.value.toFixed(2) : params.value,
    },
    {
      field: "acoes",
      headerName: "Ações",
      sortable: false,
      disableClickEventBubbling: true,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) => {
        return (
          <div className="d-flex align-items-center">
            {permissoesHelper.temPermisao("produtos-editar") && 
              <IconButton
                onClick={() => onClickEditProduto(params.row.id)}
              >
                <i
                  className="ph-fill ph-pencil"
                  style={{ color: "#494C62", fontSize: 18 }}
                ></i>
              </IconButton>
            }
            {permissoesHelper.temPermisao("produtos-excluir") && 
              renderHandleRemoverProduto(params)
            }
          </div>
      )},
    },
  ];
  const produtosService = new ProdutosService();
  const permissoesHelper = new PermisoesHelper();
  permissoesHelper.validarPermisao("produtos-visualizar");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const filtros = filtrosUrl.get();
    buscarProdutos(filtros);
  }, []);

  const renderHandleRemoverProduto = (params) => {
    return (
      params.row.movimentacaoEstoque 
      ?
        <IconButton
          onClick={() => onClickDesativarProduto(params.row.id)}
        >
          <i
            className="ph-bold ph-prohibit"
            style={{ color: "#494C62", fontSize: 18 }}
          ></i>
        </IconButton>
      :
        <IconButton
          onClick={() => onClickDeleteProduto(params.row.id)}
        >
          <i
            className="ph-fill ph-trash"
            style={{ color: "#494C62", fontSize: 18 }}
          ></i>
        </IconButton>
    );
  }

  const buscarProdutos = async (query) => {
    const filtros = {
      ...query,
      produtoGrade: true,
    };
    setLoading(true);
    const res = await produtosService.getAll(filtros);
    if (!res.isAxiosError) {
      setTotalListaProdutos(res.data.count);
      setProdutos(res.data.rows);
      filtrosUrl.set(filtros);
    } else {
      responseErros(res);
    }
    setLoading(false);
  };

  const onClickCadastrarProduto = function (descricao) {
    switch (descricao) {
      case "Excel":
        history.push("/estoque/importacao-produto");
        break;
      case "Reajuste de Preço":
        history.push("/estoque/reajuste-preco");
        break;
      case "Impressão de Etiquetas":
        setOpenDialogImpressao(true);
        break;
      default:
        history.push("/estoque/produtos/create");
        break;
    }
  };

  const onClickEditProduto = function (id) {
    history.push(`/estoque/produtos/${id}`);
  };

  const onClickDesativarProduto = async function (id) {
    const produto = produtos.find((item) => item.id === id);
    const retornoAlerta = await notification.confirmacao(
      "Desativar!",
      `Tem certeza que deseja desativar o produto '${produto?.descricao}'?`
    );
    if (retornoAlerta.isConfirmed) {
      setLoading(true);
      const result = await produtosService.desativar(id);
      if (!result.isAxiosError) {
        buscarProdutos();
        notification.sucessoGenericos("Produto desativado com sucesso.");
      } else {
        setLoading(false);
        responseErros(result);
      }
    }
  };

  const onClickDeleteProduto = async (id) => {
    const produto = produtos.find((item) => item.id === id);
    const retornoAlerta = await notification.confirmacao(
      "Excluir!",
      `Tem certeza que deseja excluir o produto '${produto?.descricao}'?`
    );
    if (retornoAlerta.isConfirmed) {
      setLoading(true);
      const result = await produtosService.deletar(id);
      if (!result.isAxiosError) {
        buscarProdutos();
        notification.sucessoGenericos("Produto excluído com sucesso.");
      } else {
        setLoading(false);
        responseErros(result);
      }
    }
  };

  const buscarPesquisaAvancada = async (filter) => {
    const porIntervalo = [];
    const filtrosAvancadosTemp = {
      ...filter,
    };
    if (
      filtrosAvancadosTemp.precoVendaStart &&
      filtrosAvancadosTemp.precoVendaEnd
    ) {
      porIntervalo.push({
        coluna: "preco_venda",
        de: parseFloat(filtrosAvancadosTemp.precoVendaStart),
        ate: parseFloat(filtrosAvancadosTemp.precoVendaEnd),
      });
    }
    delete filtrosAvancadosTemp.estoqueStart;
    delete filtrosAvancadosTemp.estoqueEnd;
    delete filtrosAvancadosTemp.precoVendaStart;
    delete filtrosAvancadosTemp.precoVendaEnd;
    for (const key in filtrosAvancadosTemp) {
      if (filtrosAvancadosTemp[key] == null) {
        delete filtrosAvancadosTemp[key];
      }
    }
    const filters = {
      ...filtrosAvancadosTemp,
      restritiva: true,
      porIntervalo,
      produtoGrade: true,
    };
    const result = await produtosService.getAllFiltroAvancado(filters);
    if (!result.isAxiosError) {
      setTotalListaProdutos(result.data.count);
      setProdutos(result.data.rows);
      filtrosUrl.set(filters);
    } else {
      responseErros(result);
    }
  };

  const sendServerDatagrid = (props) => {
    const filtros = filtrosUrl.get();
    const filtrosTemp = {
      ...filtros,
      ...props.filtros,
    };
    if (props.tipoFiltro == "simples") {
      buscarProdutos(filtrosTemp);
    } else {
      buscarPesquisaAvancada(filtrosTemp);
    }
  };

  const filtrarListaPorCodigo = (value) => {
    if (value) {
      buscarProdutos({ codigo: value });
      setBuscaFiltro("");
    } else {
      buscarProdutos();
    }
  };

  const buttonSelectOpcoes = [
    { permission: true, descricao: "Excel" },
    { permission: true, descricao: "Reajuste de Preço" },
    { permission: true, descricao: "Impressão de Etiquetas" },
  ];

  return (
    <>
      <ListLayout
        title="Produtos"
        loading={loading}
        onClickCadastrar={onClickCadastrarProduto}
        buttonSelectOpcoes={buttonSelectOpcoes}
        permissaoButton={permissoesHelper.temPermisao("produtos-cadastrar")}
      >
        <DataGrid
          rows={produtos}
          columns={colunas}
          rowCount={totalListaProdutos}
          paginationMode="server"
          sendServer={sendServerDatagrid}
          FormFiltroAvancado={FormFiltroAvancado}
          onClickEdit={onClickEditProduto}
          visualizarShow={permissoesHelper.temPermisao("produtos-visualizar")}
          disableAcoes
          enableRowDoubleClick
          FiltroCustom={
            <FiltroCustom
              buscaFiltro={buscaFiltro}
              setBuscaFiltro={setBuscaFiltro}
              sendServer={sendServerDatagrid}
              columns={colunas}
              filtrarListaPorCodigo={filtrarListaPorCodigo}
            />
          }
        />
      </ListLayout>
      <ImpressaoEtiquetasDialog
        openDialog={openDialogImpressao}
        setOpenDialog={setOpenDialogImpressao}
      />
    </>
  );
};

export default ListProdutos;
